import { Button } from "components/DesignSystem/Button/Button";
import { Tag } from "components/DesignSystem/Tag/Tag";
import {
  TASK_ADDITIONAL_PAYMENT,
  TASK_REVIEW_AND_PAY,
  TASK_REVIEW_DOCUMENT,
} from "constants/chatType";
import { ReactNode } from "react";

type ChatCardButtonProps = {
  urlText: string;
  documentOperation?: string;
  isPaymentRequired?: boolean;
  isDocReviewed?: boolean;
  handleCardAction: () => void;
  disabled?: boolean;
  amount?: string;
  customText?: string;
};

export const CustomCardButton = ({
  urlText,
  documentOperation,
  isPaymentRequired,
  isDocReviewed,
  disabled,
  handleCardAction,
  amount,
  customText,
}: ChatCardButtonProps) => {
  const isBalancePayment = documentOperation === TASK_ADDITIONAL_PAYMENT;
  const isBalancePaymentPaid =
    isDocReviewed && isBalancePayment && !isPaymentRequired;

  const isDisabled = isBalancePaymentPaid || disabled;

  let btnContent: string | ReactNode = urlText;

  if (customText) {
    return (
      <Button
        disabled={isDisabled}
        onClick={handleCardAction}
        size="small"
        customType="secondary"
      >
        {customText}
      </Button>
    );
  }

  if (isBalancePaymentPaid) {
    return (
      <Tag tagType="green" rounded>
        Paid
      </Tag>
    );
  }

  if (
    isDocReviewed &&
    !isBalancePayment &&
    documentOperation === TASK_REVIEW_DOCUMENT &&
    !isPaymentRequired
  ) {
    return (
      <Button
        block
        disabled={isDisabled}
        onClick={handleCardAction}
        size="small"
        customType="secondary"
      >
        View
      </Button>
    );
  }

  if (
    isDocReviewed &&
    !isBalancePayment &&
    documentOperation === TASK_REVIEW_AND_PAY &&
    !isPaymentRequired
  ) {
    return (
      <Button
        disabled={isDisabled}
        onClick={handleCardAction}
        size="small"
        customType="secondary"
      >
        View
      </Button>
    );
  }

  if (isBalancePayment && isPaymentRequired) {
    return (
      <Button
        disabled={isDisabled}
        onClick={handleCardAction}
        size="small"
        customType="secondary"
      >
        Pay
      </Button>
    );
  }

  if (isDocReviewed && isPaymentRequired && !isBalancePayment) {
    btnContent = amount ? `Pay $${amount}` : "Payment pending";
  }

  if (urlText.includes("Review and Pay")) {
    btnContent = "Review & Pay";
  }

  return (
    <Button
      customType="secondary"
      disabled={isDisabled}
      onClick={handleCardAction}
      size="small"
    >
      {btnContent}
    </Button>
  );
};
